module.exports = __webpack_public_path__ + "img/tipi_di_controlli_emt.cead7bd7.png";